import { render, staticRenderFns } from "./top.vue?vue&type=template&id=b3522e52&scoped=true&"
import script from "./top.vue?vue&type=script&lang=js&"
export * from "./top.vue?vue&type=script&lang=js&"
import style0 from "./top.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./top.vue?vue&type=style&index=1&id=b3522e52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3522e52",
  null
  
)

export default component.exports